import React from 'react'
import { ReviewContentBox } from '../../components'
import { useStateValue } from '@State'

export const ReviewContentLayout = () => {
  const [state] = useStateValue()
  const { certInfo, assessments, chapters } = state

  const chosenChapterIds = new Set(certInfo.selectedChapters)
  const filteredChapters = chapters.chapterChoices.filter(c =>
    chosenChapterIds.has(c.id)
  )
  const filteredAssessments = certInfo.selectedAssessments.map(
    element => assessments[element]
  )

  return (
    <div id="outer_requirements">
      <ReviewContentBox
        title="Required Assessments"
        subtitle={`Students must pass the following assessments with a score of at least ${certInfo.passingScore}%:`}
      >
        {filteredAssessments.map((a, id) => (
          <div key={id}>{a}</div>
        ))}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Reading"
        subtitle="Students must complete the following reading:"
      >
        {filteredChapters.map(c => (
          <div key={c.id}>{c.title}</div>
        ))}
      </ReviewContentBox>
      <h3 className="review_header">Certificate Description</h3>
      <div className="data_container review_content_container">
        <div>{certInfo.description}</div>
      </div>
    </div>
  )
}
